import { render, staticRenderFns } from "./EzProductModal.vue?vue&type=template&id=56fa8037&scoped=true&"
import script from "./EzProductModal.vue?vue&type=script&lang=js&"
export * from "./EzProductModal.vue?vue&type=script&lang=js&"
import style0 from "./EzProductModal.vue?vue&type=style&index=0&id=56fa8037&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fa8037",
  null
  
)

export default component.exports